/**
 * Validation utilities for form validation
 */

/**
 * Validates that the end date is after the start date
 * @param startDate - The start date to validate
 * @param endDate - The end date to validate
 * @param errorMessage - The error message to return if validation fails
 * @returns The error message if validation fails, undefined otherwise
 */
export const validateDateRange = (
  startDate: Date | null | undefined,
  endDate: Date | null | undefined,
  errorMessage: string
): string | undefined => {
  if (startDate && endDate && startDate > endDate) {
    return errorMessage;
  }
  return undefined;
};

/**
 * Validates SKU attribute dates conditionally based on whether the attribute type allows dates
 * @param allowDates - Whether the attribute type allows dates
 * @param startDate - The start date to validate
 * @param endDate - The end date to validate
 * @param errorMessage - The error message to return if validation fails
 * @returns The error message if validation fails, undefined otherwise
 */
export const validateSkuAttributeDates = (
  allowDates: boolean | undefined,
  startDate: Date | null | undefined,
  endDate: Date | null | undefined,
  errorMessage: string
): string | undefined => {
  if (!allowDates) {
    return undefined;
  }
  return validateDateRange(startDate, endDate, errorMessage);
};
